import { Typography } from '@mui/material';
import MuiTooltip from '@mui/material/Tooltip';
import { isOverflown } from 'core/utils/domUtils';
import { isEmpty, isNil } from 'lodash';
import { forwardRef, useCallback, useRef, useState } from 'react';
import type { TooltipProps } from '@mui/material';
import type { FC } from 'react';

interface OrderDocumentTitleProps {
  title: string;
}

const DocNameTooltip = forwardRef<HTMLDivElement, TooltipProps>(function DocNameTooltip(
  props,
  ref
) {
  return (
    <MuiTooltip
      slotProps={{
        popper: {
          modifiers: [
            {
              name: 'offset',
              options: {
                offset: [0, -14],
              },
            },
          ],
        },
      }}
      ref={ref}
      {...props}
    />
  );
});

const OrderDocumentTitle: FC<OrderDocumentTitleProps> = ({ title }) => {
  const [tooltip, setTooltip] = useState('');
  const titleRef = useRef<HTMLDivElement>(null);

  const handleMouseOver = useCallback<React.MouseEventHandler<HTMLDivElement>>(() => {
    if (!isEmpty(title)) {
      const isOver = !isNil(titleRef.current) && isOverflown(titleRef.current);
      if (isOver) {
        setTooltip(title);
      } else {
        setTooltip('');
      }
    }
  }, [title]);

  return (
    <DocNameTooltip title={tooltip}>
      <Typography
        ref={titleRef}
        align='center'
        variant='body2'
        sx={{
          display: '-webkit-box',
          overflow: 'hidden',
          WebkitBoxOrient: 'vertical',
          WebkitLineClamp: 2,
          textWrap: 'balance',
        }}
        onMouseOver={handleMouseOver}>
        {title}
      </Typography>
    </DocNameTooltip>
  );
};

export default OrderDocumentTitle;
